<template>
<div class="mt20 page-box">
   <el-pagination
    background
    :current-page="currentPage"
    :page-sizes="[10, 25, 50, 100]"
    :page-size="pageSize"
    :layout="layout"
    :page-count="pageCount?pageCount:null"
    :total="pageCount?null:total"
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange">
  </el-pagination>
</div>
</template>
<script>
import {Pagination} from 'element-ui'
export default {
  name:'paginationBox',
  props:{
    currentPage:{
      type:Number,
      default:1
    },
    pageSize:{
      type:Number,
      default:10
    },
    total:{
      type:Number,
      default:0
    },
    pageCount:{
      type:Number,
      default:0
    },
    layout:{
      type:String,
      default : 'total, prev, pager, next, jumper'
    },


  },
  data(){
    return {

    }
  },
  methods:{
    handleSizeChange(val) {
      this.$emit('sizeChange',val);
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.$emit('currentChange',val)
      // console.log(`当前页: ${val}`);
    }
  },
  components:{
    elPagination:Pagination
  }
}
</script>
<style scoped>
.page-box{
  display: flex;
  justify-content: flex-end;
}
</style>


// WEBPACK FOOTER //
// src/components/paginationBox.vue